import { jsx as _jsx } from "react/jsx-runtime";
import { Textarea as ChakraTextarea, } from '@chakra-ui/react';
import React from 'react';
export const Textarea = React.forwardRef((props, ref) => {
    return _jsx(ChakraTextarea, { ref: ref, ...props });
});
//# sourceMappingURL=textarea.js.map